/* NX1 PROJECT | Glaze | sticky add to cart bar on product pages. Uses the main form, so offers and jar picks carry over. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nx-pdp]');
  if (!root) return;
  var form = root.querySelector('[data-nx-product-form]');
  var atc = form && form.querySelector('[data-nx-atc]');
  if (!atc) return;
  var img = root.querySelector('[data-nx-main-img]');
  var titleEl = root.querySelector('.nx-pdp__title');
  var footer = document.querySelector('.nx-footer') || document.querySelector('footer');
  var bar = document.createElement('div');
  bar.className = 'nx-sticky';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div class="nx-sticky__inner"><span class="nx-sticky__img"></span><span class="nx-sticky__info"><span class="nx-sticky__title"></span><span class="nx-sticky__price"></span></span><button type="button" class="nx-btn nx-btn--dark nx-sticky__btn" tabindex="-1"></button></div>';
  document.body.appendChild(bar);
  var btn = bar.querySelector('button');
  var titleOut = bar.querySelector('.nx-sticky__title');
  var priceOut = bar.querySelector('.nx-sticky__price');
  var imgOut = bar.querySelector('.nx-sticky__img');
  var visible = false, ticking = false;

  function esc(s) { var d = document.createElement('span'); d.textContent = s || ''; return d.innerHTML; }
  function sync() {
    titleOut.textContent = titleEl ? titleEl.textContent.trim() : '';
    var offer = root.querySelector('[data-nx-offer].is-active');
    var price = offer ? offer.querySelector('[data-nx-offer-price]') : root.querySelector('[data-nx-price]');
    priceOut.innerHTML = (offer && offer.dataset.name ? '<b>' + esc(offer.dataset.name) + '</b>' : '') + (price ? price.innerHTML : '');
    var src = img && (img.currentSrc || img.src);
    if (src && imgOut.dataset.src !== src) { imgOut.dataset.src = src; imgOut.innerHTML = '<img src="' + esc(src) + '" alt="">'; }
    btn.textContent = atc.textContent.trim();
    btn.disabled = atc.disabled;
  }
  /* Show once the main button has scrolled off the top, hide again near the footer. */
  function check() {
    ticking = false;
    var pastAtc = atc.getBoundingClientRect().bottom < 0;
    var footerIn = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
    var show = pastAtc && !footerIn;
    if (show === visible) return;
    visible = show;
    if (show) sync();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();

  new MutationObserver(function () { if (visible) sync(); }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'src'] });
  btn.addEventListener('click', function () {
    if (atc.disabled) return;
    if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
  });
})();